import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/noVisitAfterFirstVisitSagas";
import MonthPicker from "../../../../components/reactMonthPicker/reactMonthPicker";

const DatePicker = () => {
  const {
    selectedRequestDates: { startDate, endDate },
    currentUser: { calendarStartDate, calendarEndDate }
  } = useSelector((state) => {
    let { selectedRequestDates, currentUser } = state.noVisitAfterFirstVisit;
    return { selectedRequestDates, currentUser };
  }, shallowEqual);

  const dispatch = useDispatch();

  return (
    <MonthPicker
      startDate={startDate}
      endDate={endDate}
      calendarStartDate={calendarStartDate}
      calendarEndDate={calendarEndDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    />
  );
};

export default DatePicker;
